import { css } from "@emotion/react";
import styled from "@emotion/styled";
import colors from "src/utils/colors";

interface ItemMetaProps {
  isActive?: boolean;
  className?: string;
}

const activeStyles = css`
  color: ${colors.dark};
`;

export default styled("div")<ItemMetaProps>`
  font-size: 0.9rem;
  & p {
    color: #999;
    /* margin: 0 0 0.5rem 0; */
    ${(props: ItemMetaProps) => props.isActive && activeStyles};
  }
`;
